import type { Language } from './VoiceOrderingContainer';

/**
 * Extract English name from bilingual format "Arabic | English"
 */
export function getItemName(item: string, language: Language): string {
  const parts = item.split('|').map((s) => s.trim());
  if (parts.length === 2) {
    return language === 'ar' ? parts[0] : parts[1];
  }
  return item;
}

/**
 * Extract Arabic name from bilingual format "Arabic | English"
 */
export function getArabicName(item: string): string {
  const parts = item.split('|').map((s) => s.trim());
  return parts.length === 2 ? parts[0] : '';
}

/**
 * Format price with currency symbol based on language
 */
export function formatPrice(priceEGP: number, language: Language): string {
  const currency = language === 'en' ? 'EGP' : 'ج.م';
  return `${priceEGP.toFixed(1)} ${currency}`;
}

